import { Component, inject, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { BaseComponent } from '../../../shared/utils/base.component';
import { SectionsService } from '../../../services/sections.service';
import { ENROLLMENT_TYPE_BACKEND_MAPPINGS, STATIC_DATA, PROVIDER_TYPES, RADIO_YES_NO_OPTIONS, STATIC_JSON_DATA_PATH, ProviderCode } from '../../../shared/constants/static-data.constants';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzFormModule } from 'ng-zorro-antd/form';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { CommonModule } from '@angular/common';
import { ReferralDataService } from '../../../services/referral-data.service';
import { ButtonComponent } from '@ppl/ui';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { ListTableComponent } from '@ppl/ui';
import { EnrollmentDataService } from '../../../services/enrollment-data.service';
import { DeleteAssociationModel, PrtcpntPrvdrAssociationModel } from '../../../shared/interfaces/participant-association.model';
import { EditMode } from '../../../interfaces/edit-mode.model';
import { DialogConfig, DialogService } from '../../../shared/services/dialog.service';
import { UserService } from '../../../services/user.service';
import { StorageService } from '../../../services/storage.service';
import { LeadDetailsService } from '../../../services/lead-details.service';
import { ViewportService } from '../../../services/view-port.service';
import { AutoFocusFirstInputDirective } from '../../../shared/directives/auto-focus-first-input.directive';

@Component({
  selector: 'ppl-new-contact',
  standalone: true,
  imports: [
    NzCardModule,
    NzFormModule,
    ReactiveFormsModule,
    NzToolTipModule,
    NzRadioModule,
    CommonModule,
    ButtonComponent,
    NzCollapseModule,
    ListTableComponent
  ],
  templateUrl: './new-contact.component.html',
  styleUrl: './new-contact.component.css',
})
export class NewContactComponent extends BaseComponent implements OnInit {
  @Input() mode = 'edit';
  readonly editMode = EditMode;
  radioOptions = RADIO_YES_NO_OPTIONS;
  newContactForm!: FormGroup;
  show = false;
  associationDetailsData: any = {};
  entry: string | null = '';
  associations: any = [];
  flow = '';
  program: any;

  cols: any = [];
  participantCols: any[] = [];
  associationCols: any = [];
  participantAssociations: any[] = [];
  mandatoryAssociations: any[] = [];
  isStepMandatory = false;
  @ViewChild('confirmationDialog') confirmationDialog!: TemplateRef<any>;
  @ViewChild('deleteConfirmationDialog') deleteConfirmationDialog!: TemplateRef<any>;
  private dialogSvc = inject(DialogService);
  isConsumerAbove18 = false;
  consumerData: any;
  participantId: any;
  isGoodsAndServicesOnly = false;
  isEmpValid = true;
  empValidationErrorMessage = '';
  isParticipantMinor = false;

  actions: any = {
    "edit": false,
    "delete": false,
    "view": true,
    "download": false,
    "verify": false,
    "add": false
  }

  allowMultiple = {
    AR: true,
    EMP: true,
    IR: true,
    IC: true,
    VE: true,
    IF: true,
    POA: true,
    CNV: true,
    LG: true
  };

  constructor(
    private sectionsService: SectionsService,
    private fb: FormBuilder,
    private referralDataService: ReferralDataService,
    private enrollmentDataService: EnrollmentDataService,
    private userService: UserService,
    private storageService: StorageService,
    private leadDetailsService: LeadDetailsService,
    public viewport: ViewportService
  ) {
    super();
  }

  activeKeys: string[] = [];
  allPanelsExpanded = false;

  ngOnInit(): void {
    this.newContactForm = this.fb.group({
      newEmployer: ['No'],
      newAuthRep: ['No'],
      newVendor: ['No'],
      newIndependentFacilitator: ['No'],
      newProvider: ['No'],
      newContractor: ['No'],
      newPOA: ['No'],
      newLegalGuardian: ['No'],
    });
    this.entry = this.userService.getLeadEntry() ?? '';
    this.flow = this.sectionsService.getFlow() ?? '';
    this.program = this.userService.getSelectedProgram();
    const steps = this.sectionsService.getSectionData(this.program.program_code);
    // const leadId = this.userService.getSelectedLead()!;
    this.participantId = this.storageService.getParticipantId()!;
    this.secData = steps['associations'];
    this.mandatoryAssociations = this.secData.attributes.filter((data: any) => {
      return data.mandatory === 'Y';
    });

    const referralData = this.referralDataService.getReferralFormData();
    this.isGoodsAndServicesOnly = referralData?.infoData?.recieveGoodsAndServices === 'Yes' ? true : false;

    console.log("this.mandatoryAssociations--------------", this.mandatoryAssociations);
    if (this.sectionsService.getFlow() === 'providerEnrollment') {
      this.mode = 'read'
      // this.referralDataService.setReferralFormData(
      //   'isAssociationsFormDirty',true
      // );
      // this.referralDataService.setReferralFormData(
      //   'isAssociationsFormUpdated',true
      // );
    }

    const controls = [
      'newEmployer',
      'newAuthRep',
      'newProvider',
      'newVendor',
      'newIndependentFacilitator',
      'newContractor',
      'newLegalGuardian',
      'newPOA',
    ];

    controls.forEach((control) => {
      this.newContactForm.get(control)?.valueChanges.subscribe((value) => {
        this.onRadioChange(control, value);
      });
    });

    const data = this.sectionsService.getAllSteps(this.program.program_code);
    const associationStep = data.find((step: any) => step.step_id === STATIC_DATA.ASSOCIATIONS);
    this.isStepMandatory = associationStep ? associationStep.isMandatory === 'Y' : false;
    this.getGridHeaders();
    this.getFileCols();
    this.getAssocGridHeaders();
    this.enrollmentDataService.getParticipantAssocChanged().subscribe(() => {
      this.getAssociationDetails(this.program.program_code, this.participantId);
    });
    this.getAssociationDetails(this.program.program_code, this.participantId);
    if (this.sectionsService.getFlow() === 'providerEnrollment') {
      const filledData = this.referralDataService.getReferralDetails(
        'participantAssociations'
      )!;
      if (filledData) {
        this.associations = filledData;
      }
    }
    else {
      this.getConsumerDetails();
    }
    this.referralDataService.nextClicked.subscribe((val) => {
      if (val === STATIC_DATA.ASSOCIATIONS) {
        this.referralDataService.setStepValidation({ step: STATIC_DATA.ASSOCIATIONS, val: this.checkFieldData() ? true : 'noVal' });
      }
    });
  }

  checkAge(date: string) {
    const [month, day, year] = date.split('/').map(Number);
    const dob = new Date(year, month - 1, day);
    const today = new Date();
    let age = today.getFullYear() - dob.getFullYear();
    const monthDiff = today.getMonth() - dob.getMonth();
    const dayDiff = today.getDate() - dob.getDate();
    if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
      age--;
    }
    this.isConsumerAbove18 = age >= 18;
  }

  async getFileCols() {
    const tempCols = await this.sectionsService.getJsonConfigurationData(
      STATIC_JSON_DATA_PATH.PARTICIPANT_ASSOCIATIONS_HEADERS
    );
    this.associationCols = tempCols?.columns;
  }

  flattenData(data: Record<string, any[]>): any[] {
    return Object.values(data).flat();
  }

  getAssociationDetails(program_code: string, participantId: any) {
    console.log('leadId', participantId);
    if (participantId) {
      const isParticipant = this.flow === 'participantEnrollment';
      this.enrollmentDataService.getAssociationsDetails(program_code, participantId, isParticipant, true).subscribe((response: any) => {
        console.log(response.responsedata);
        const data = response.responsedata;
        this.participantAssociations = this.flattenData(response.responsedata);
        this.checkParticipantMinorStatus();

        const restrictedProviderCodes: ProviderCode[] = ['AR', 'EMP', 'POA', 'LG'];
        for (const key in PROVIDER_TYPES) {
          this.associationDetailsData[key] = data[key] || [];

          if (data[key]?.length && restrictedProviderCodes.includes(key as ProviderCode)) {
            const activeCount = data[key].filter((entry: any) => entry.isActive).length;
            const maxActive = key === 'AR' ? 2 : 1;
            this.allowMultiple[key as ProviderCode] = activeCount < maxActive;
          }

          const minorRestrictedCodes: ProviderCode[] = ['POA', 'CNV'];
          if (this.isParticipantMinor && minorRestrictedCodes.includes(key as ProviderCode)) {
            this.allowMultiple[key as ProviderCode] = false;
          }
        }
        this.checkFieldData();
      });
    }
  }

  action(event: any): void {
    if (event.action === 'disassociate') {
      this.checkAge(this.consumerData.dob);
        this.openConfirmationPopup(event.data);
    } else if (event.action === 'view') {
      console.log('view event', event);
      this.referralDataService.setAssociationsEditable(true);
      const payload = {
        programCode: this.program.program_code,
        providerId: event.data.providerId,
        providerType: event.data.associationTypeCode,
        partiProviderAssocId: event.data.partiProviderAssocId
      };
      this.enrollmentDataService
        .fetchParticipantAssociations(payload)
        .subscribe((response: any) => {
          console.log('Edit response', response);
          this.referralDataService.setAssociationDetails(response.responsedata);
          this.addAssociation(ENROLLMENT_TYPE_BACKEND_MAPPINGS[event.data.associationTypeCode], EditMode.Add)
          // const flattenedData = this.flattenResponse(response);
          // console.log(flattenedData.responsedata);
          // this.infoForm.patchValue(flattenedData.responsedata);
        });
    }
  }

  disassociate(data: PrtcpntPrvdrAssociationModel) {
    const program = this.userService.getSelectedProgram();
    const payload: DeleteAssociationModel = {
      associationType: data.associationTypeCode,
      participantId: data.participantId,
      providerId: data.providerId,
      programCode: program?.program_code ?? ''
    };
    this.deleteAccociation(payload);
  }

  deleteAccociation(payload: DeleteAssociationModel) {
    this.enrollmentDataService.deleteParticipantProviderAssociation(payload, true).subscribe((response: any) => {
      console.log('Edit response', response);
      this.enrollmentDataService.setParticipantAssocChanged(true);
    });
  }


  openConfirmationPopup(data: PrtcpntPrvdrAssociationModel) {
    const dialogConfig: DialogConfig = {
      title: 'Confirmation',
      okText: 'Ok',
      size: 'medium',
      position: 'top',
      showClose: true,
      showButtons: true,
    };

    this.dialogSvc.openDialog(
      this.confirmationDialog,
      dialogConfig,
      () => this.disassociate(data),
      () => this.handleCancel()
    );
  }
  openDeleteConfirmationPopup() {
    const dialogConfig: DialogConfig = {
      title: 'Error',
      okText: 'Ok',
      size: 'medium',
      position: 'top',
      showClose: true,
      showOkButton: true,
      showButtons: false,
    };

    this.dialogSvc.openDialog(
      this.deleteConfirmationDialog,
      dialogConfig,
      () => this.handleCancel(),
      () => this.handleCancel()
    );
  }

  handleCancel() { }

  async getGridHeaders() {
    try {
      if (this.flow) {
        const tempCols = await this.sectionsService.getJsonConfigurationData(
          STATIC_JSON_DATA_PATH.ASSOCIATIONS_DETAILS_HEADERS, this.flow
        );
        this.cols = tempCols.columns;
      }
    } catch {
      // this.logger.debug('Communication logs - Error in getting column data', err);
    }

  }


  async getAssocGridHeaders() {
    try {
      if (this.flow) {
        const tempCols = await this.sectionsService.getJsonConfigurationData(
          STATIC_JSON_DATA_PATH.ALL_ASSOCIATIONS_DETAILS_HEADERS, this.flow
        );
        this.participantCols = tempCols.columns;
      }
    } catch {
      // this.logger.debug('Communication logs - Error in getting column data', err);
    }
  }

  getProviderData(providerCode: string) {

    const data = this.associationDetailsData[providerCode] || [];
    data.forEach((e: any) => {
      if (e.associationStatus != 'Disassociated') {
        e.actions = {
          'showDisassociate': true
        }
      }
    });
    return data;
  }

  getDRCount() {
    const activeDRs = this.associationDetailsData['AR'].filter(
      (item: any) => item.associationStatus !== 'Disassociated'
    );
    return activeDRs.length;
  }

  getConsumerDetails() {
    this.leadDetailsService
      .getLeadDetails(this.flow, this.program.program_code, this.participantId, true)
      .subscribe((data: any) => {
        this.consumerData = data?.responsedata?.infoData;
      });
  }

  checkParticipantMinorStatus() {
    const dob = this.referralDataService.getReferralFormData()?.infoData?.dob || this.consumerData?.dob;
    if (dob) {
      const birthDate = new Date(dob);
      const age = Math.floor((Date.now() - birthDate.getTime()) / (365.25 * 24 * 60 * 60 * 1000));
      this.isParticipantMinor = age < 18;
    }
  }

  getProviderColumns(providerCode: string) {
    let data = this.cols;

    if (providerCode !== 'Vendor' && providerCode !== 'IC' && providerCode !== 'IF') {
      data = data.filter((e: any) => e.field !== 'legalName');
    }

    if (providerCode != "AR" && providerCode != "IR") {
      data = data.filter((e: any) => e.field != 'relationToParticipant');
    }

    return data;
  }

  checkFieldData(): boolean {
    if (this.entry === 'participantEnrollment') {
      const hasAnyAssociation = Object.values(this.associationDetailsData || {}).some((association: any) => association?.length > 0);

      if (!this.isGoodsAndServicesOnly) {
        const empAssociations = this.associationDetailsData?.EMP || [];

        this.isEmpValid = empAssociations.some((emp: any) => emp.isActive === true);

        if (!this.isEmpValid) {
          this.empValidationErrorMessage =
            'One active Employer association is required when Goods and Services Only is set to No.';
        }
      }

      return hasAnyAssociation && this.isEmpValid;
    }

    return true;
    //Do not delete the below commented code

    // if(this.mandatoryAssociations.length === 0 || this.flow === 'providerEnrollment'){
    //   return true;
    // }
    // return this.mandatoryAssociations.every(item => {
    //   const fieldName = item.fieldName.replace('new', '');
    //   const mappedFieldName = ENROLLMENT_TYPE_UI_TO_BACKEND_MAPPINGS[fieldName.toLowerCase()];
    //   return mappedFieldName && this.associationDetailsData[mappedFieldName] && this.associationDetailsData[mappedFieldName].length > 0;
    // });
  }

  onRadioChange(controlName: string, value: string) {
    if (value === 'Yes') {
      this.sectionsService.setEnrollmentType(JSON.stringify([controlName]));
      //this.referralDataService.clearReferrralData();
      this.referralDataService.setFlowForAssociation({ val: true, flow: controlName });
    }
  }

  addAssociation(control: string, editMode?: EditMode) {
    this.sectionsService.setEnrollmentType(JSON.stringify([control]));
    if (editMode !== EditMode.Add) {
      this.referralDataService.clearAssociationsFormData();
    }
    //this.referralDataService.clearReferrralData();
    const flowParams: any = { val: true, flow: control }
    if (editMode) {
      flowParams.editMode = editMode;
      console.log("FLOW PARAMS", flowParams)
    }
    this.referralDataService.setFlowForAssociation(flowParams);
    // this.referralDataService.setReferralFormData(
    //   'isAssociationsFormDirty', true
    // );
    // this.referralDataService.setReferralFormData(
    //   'isAssociationsFormUpdated', true
    // );
  }

  // viewAssociation(control: string){
  //   this.enrollmentDataService
  //       .fetchParticipantAssociations(payload)
  //       .subscribe((response: any) => {
  //         console.log('Edit response', response);
  //         const flattenedData = this.flattenResponse(response);
  //         console.log(flattenedData.responsedata);
  //         this.infoForm.patchValue(flattenedData.responsedata);
  //       });
  // }

  hideAll() {
    this.activeKeys = [];
  }

  expandAll() {
    this.activeKeys = ['1', '2', '3', '4', '5', '6', '7', '8', '9'];
  }

  togglePanel(key: string): void {
    if (this.isPanelActive(key)) {
      this.activeKeys = this.activeKeys.filter((k) => k !== key);
    } else {
      this.activeKeys.push(key);
    }
  }

  isPanelActive(key: string): boolean {
    return this.activeKeys.includes(key);
  }
}
